module.exports = __webpack_public_path__ + "static/media/lewis_co.1e0f41b2.jpg";